import { useLocalization } from '@wix/package-picker-shared-studio';
import { FeaturesGrid as PlatformFeaturesGrid } from '@wix/premium-purchase-platform/@components';
import { CreativeOffer } from '@wix/premium-purchase-platform/@sdk';
import classNames from 'classnames';
import React from 'react';
import { StudioPackagePickerModule } from '../../modules/studio-package-picker.module';
import styles from './FeaturesGrid.scss';

interface FeaturesGridFeatureRowValueProps {
  comparisonValue?: CreativeOffer.ComparisonValue;
}

export const FeaturesGridFeatureRowValue = ({
  comparisonValue,
}: FeaturesGridFeatureRowValueProps) => {
  const { t } = StudioPackagePickerModule.internals.useTranslations();
  const { shouldShowJapaneseExperience } = useLocalization();

  if (comparisonValue?.available && comparisonValue?.value?.translationKey) {
    return (
      <PlatformFeaturesGrid.Content.FeatureRow.Value
        value={t(comparisonValue.value.translationKey)}
      />
    );
  }

  return (
    <PlatformFeaturesGrid.Content.FeatureRow.Value
      classNames={{
        checkIcon: classNames(styles.checkIcon, {
          [styles.japan]: shouldShowJapaneseExperience,
        }),
        minusIcon: styles.minusIcon,
      }}
      value={!!comparisonValue?.available}
    />
  );
};
